import styles from './ExternalLink.module.scss';

/**
 * An outbound link that is safe (`rel="noreferrer"`) and honest: the arrow is
 * decorative, but the destination change is announced to screen readers.
 */
function ExternalLink({ href, children, className, showIcon = true }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={[styles.link, className].filter(Boolean).join(' ')}
    >
      <span className={styles.label}>{children}</span>
      {showIcon && (
        <svg
          className={styles.icon}
          viewBox="0 0 16 16"
          width="1em"
          height="1em"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M5 11 11 5M6 5h5v5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <span className="visually-hidden"> (opens in a new tab)</span>
    </a>
  );
}

export default ExternalLink;
